import { useEffect, useState, useCallback } from 'react';
import requestSupportApis from '../../../../services/requestSupportApis';
import { IRequestSupport } from '../../interfaces/apis';
import { AxiosResponse } from 'axios';
import { IEmployeeContent, IGetEmployeesResponse } from '../../../employees/services/types';
import accountApis from '../../../../services/accountApis';

const useGetAllEmployees = (isLazy = false) => {
  const [data, setData] = useState<IEmployeeContent[] | null>(null);

  const fetchData = useCallback(async (param?: { shopId?: string[] }) => {
    try {
      const response: AxiosResponse<{ data: IGetEmployeesResponse }> = await accountApis.getEmployees({
        page: 1,
        size: 1000,
      });

      if (response?.status === 200) {
        setData(response.data.data.content);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (!isLazy) {
      fetchData();
    }
  }, [isLazy, fetchData]);

  return {
    data,
    refetch: fetchData,
  };
};

export default useGetAllEmployees;
